module.exports = __webpack_public_path__ + "img/safety--full-mobile.c463bca0.jpg";